import styled, { css } from "styled-components";
import { colors } from "../../../theme/theme";

interface NavProps {
	show: boolean;
	showUserInfo: boolean;
}

const wrapperModifiers = {
	showMenu: () => css`
		width: 211px;
		transition: width 0.3s;
	`,
};

export const Nav = styled.nav<NavProps>`
	${({ show }) => css`
		background: #fff;
		position: fixed;
		left: 0;
		top: 0;
		height: 100vh;
		width: 80px;
		border-right: 0.5px solid ${colors.mainColors.very_light_green};
		z-index: 9;
		transition: width 0.3s;

		display: flex;
		flex-direction: column;

		@media (max-width: 600px) {
			width: 100%;
			position: absolute;
			display: ${show ? "block" : "none"};
		}

		${show && wrapperModifiers.showMenu()};
	`}

	.notification-wrapper {
		position: relative;
		width: 100%;
	}

	.notification-badge.p-badge.p-badge-danger {
		background: ${colors.danger.red_41};
		font-size: 12px;
		font-weight: 400;

		justify-content: center;

		padding: 0 6px;
		border-radius: 16px;

		line-height: 0;

		display: flex;
		align-items: center;
		justify-content: center;

		position: absolute;
		right: 4px;
		top: 50%;

		transform: translateY(-50%);

		&.collapsed {
			top: 0;
			right: -20px;
		}
	}
`;

export const MenuLogoBox = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	strong {
		margin-top: 5px;
	}
`;

export const MenuList = styled.ul<NavProps>`
	padding: 0;
	margin-top: 20px;

	@media (max-width: 600px) {
		.flex-column {
			display: ${({ showUserInfo }) =>
				!showUserInfo ? "block" : "none"};
		}
	}
`;
